var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-select", {
    staticClass: "insect-filter-select",
    staticStyle: { width: "170px" },
    attrs: {
      value: _vm.value,
      items: _vm.filterOptions,
      "item-text": "text",
      "item-value": "value",
      dense: "",
      outlined: "",
      "hide-details": "",
    },
    on: {
      change: function ($event) {
        return _vm.$emit("input", $event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function (ref) {
          var item = ref.item
          var on = ref.on
          var attrs = ref.attrs
          return [
            item.isGroup
              ? _c(
                  "v-list-item",
                  _vm._g(
                    _vm._b(
                      { staticClass: "group-header" },
                      "v-list-item",
                      attrs,
                      false
                    ),
                    on
                  ),
                  [
                    _c(
                      "v-list-item-content",
                      [
                        _c(
                          "v-list-item-title",
                          { staticClass: "font-weight-bold" },
                          [
                            _vm._v(
                              "\n          " + _vm._s(item.text) + "\n        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _c(
                  "v-list-item",
                  _vm._g(
                    _vm._b(
                      { class: { "pl-6": item.indent } },
                      "v-list-item",
                      attrs,
                      false
                    ),
                    on
                  ),
                  [
                    _c(
                      "v-list-item-content",
                      [_c("v-list-item-title", [_vm._v(_vm._s(item.text))])],
                      1
                    ),
                  ],
                  1
                ),
          ]
        },
      },
      {
        key: "selection",
        fn: function (ref) {
          var item = ref.item
          return [
            _c("span", { staticClass: "selection-text" }, [
              _vm._v(_vm._s(item.text)),
            ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }